<template>
  <div class="home-page-wrapper">
    <div class="hero-video-wrapper" v-if="videoBgLargeUrl || videoBgSmallUrl">
      <!-- Desktop Video -->
      <div class="video-desktop" v-if="videoBgLargeUrl">
        <video 
          ref="videoDesktopRef"
          :src="videoBgLargeUrl" 
          autoplay 
          loop 
          muted 
          playsinline 
          class="hero-video"
        ></video>
      </div>
      
      <!-- Mobile Video -->
      <div class="video-mobile" v-if="videoBgSmallUrl">
        <video 
          ref="videoMobileRef"
          :src="videoBgSmallUrl" 
          autoplay 
          loop 
          muted 
          playsinline 
          class="hero-video"
        ></video>
      </div>

      <!-- Mute/Unmute Toggle Button -->
      <button class="mute-toggle-btn" @click="toggleMute">
        <svg v-if="isMuted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-x"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>
      </button>
    </div>

    <FilterSearchBar v-model="searchQuery" />

    <Catalogue :modelValue="filteredProducts" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { fetchApi } from "../utils/api";
import FilterSearchBar from "../components/FilterSearchBar.vue";
import Catalogue from "../components/CatalogueList.vue";
//import { useRouter } from "vue-router";
import { STORE_ID } from "../config";
import { useStoreConfig } from "../services/storeService";

const { storeConfig, fetchStoreConfig } = useStoreConfig();

const productList = ref([]);
const categoryList = ref([]);
const selectedCategory = ref(null);
const searchQuery = ref("");
const loading = ref(true);
const baseURL = "https://zoxcom.se7enwear.com";

const videoDesktopRef = ref(null);
const videoMobileRef = ref(null);
const isMuted = ref(true);

const videoBgLargeUrl = computed(() => {
  if (storeConfig.value && storeConfig.value.video_bg_large && storeConfig.value.video_bg_large_active) {
    return `${baseURL}${storeConfig.value.video_bg_large}`;
  }
  return null;
});

const videoBgSmallUrl = computed(() => {
  if (storeConfig.value && storeConfig.value.video_bg_small && storeConfig.value.video_bg_small_active) {
    return `${baseURL}${storeConfig.value.video_bg_small}`;
  }
  return null;
});

const toggleMute = () => {
  isMuted.value = !isMuted.value;
  if (videoDesktopRef.value) {
    videoDesktopRef.value.muted = isMuted.value;
  }
  if (videoMobileRef.value) {
    videoMobileRef.value.muted = isMuted.value;
  }
};

onMounted(async () => {
  await fetchStoreConfig();
  getProducts();
  getCategory();
  const slider = categoryListRef.value;

  if (!slider) return; // 🔥 évite le crash

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeftStart = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5;
    slider.scrollLeft = scrollLeftStart - walk;
  });

});
//const router = useRouter();

// Produits filtrés selon la recherche et la catégorie
const filteredProducts = computed(() => {

  return productList.value.filter((product) => {
    const pdt = product
    
    const matchSearch =
      !searchQuery.value ||
      pdt.name.toLowerCase().includes(searchQuery.value.toLowerCase());
    const isActive = pdt.prodActive == 1;

    let matchCategory = true;
    if (selectedCategory.value) {
      matchCategory = pdt.category == selectedCategory.value.id;
    }

    // Store Filter
    let matchStore = true;
    
    try {
      if (pdt.stores_active && STORE_ID != null) {
        let stores = pdt.stores_active;

        if (typeof stores === "string") {
          try {
            stores = JSON.parse(stores);
          } catch {
            stores = [];
          }
        }

        if (Array.isArray(stores)) {
          matchStore =
            stores.includes(STORE_ID) ||
            stores.includes(String(STORE_ID)) ||
            stores.includes(Number(STORE_ID));
        } else {
          matchStore = false;
          console.error("no store found");
        }
      }
    } catch (e) {
      console.error("Error checking stores_active", e);
    }

    return matchSearch && isActive && matchCategory && matchStore;
  });
});


/*const selectCategory = (category) => {
  if (selectedCategory.value && selectedCategory.value.id === category.id) {
    selectedCategory.value = null; // Deselect if already selected
  } else {
    selectedCategory.value = category;
  }
};

const goToCatalog = () => {
  router.push(`/produits`);
};*/

// Récupération des produits depuis l’API
const getProducts = async () => {
  loading.value = true
  try {
    const response = await fetchApi(
      `${baseURL}/backend/api.php?token=test&action=getProducts`
    );

    if (!response.ok) {
      console.error(
        "Erreur lors de la récupération des produits:",
        response.statusText
      );
      return;
    }

    const result = await response.json();

    // Normalize data: map imageUrls to image if necessary
    if (result.data) {
      productList.value = result.data
    } else {
      productList.value = [];
    }
  } catch (error) {
    console.error("Une erreur est survenue:", error);
  }

  loading.value = false
};

// Récupération des catégories depuis l’API
const getCategory = async () => {
  try {
    const response = await fetchApi(
      `${baseURL}/backend/api.php?token=test&action=getCategory`
    );

    if (!response.ok) {
      console.error(
        "Erreur lors de la récupération des catégories:",
        response.statusText
      );
      return;
    }

    const text = await response.text();
  
    let result;
    try {
      result = JSON.parse(text);
    } catch (e) {
      console.error("Erreur de parsing JSON pour getCategory:", e);
      return;
    }
    categoryList.value = result.categories;
  } catch (error) {
    console.error("Une erreur est survenue:", error);
  }
};

const categoryListRef = ref(null);

//const scrollAmount = 200;

/*const scrollLeft = () => {
  categoryListRef.value.scrollBy({
    left: -scrollAmount,
    behavior: "smooth",
  });
};

const scrollRight = () => {
  categoryListRef.value.scrollBy({
    left: scrollAmount,
    behavior: "smooth",
  });
};*/

let isDown = false;
let startX;
let scrollLeftStart;

</script>

<style scoped>
.hero-video-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--dark);
}

.hero-video {
  width: 100%;
  object-fit: cover;
  pointer-events: none;
}

.video-desktop, .video-mobile {
  width: 100%;
}

.video-desktop {
  display: block;
}

.video-mobile {
  display: none;
}

@media (max-width: 767px) {
  .video-desktop {
    display: none;
  }
  .video-mobile {
    display: block;
  }
}

.mute-toggle-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  background-color: rgba(221, 255, 243, 0.4);
  backdrop-filter: blur(4px);
  color: var(--text-dark);
  transition: all 0.3s ease;
  border: 1px solid rgba(221, 255, 243, 0.4);
  z-index: 10;
}

.mute-toggle-btn:hover {
  transform: scale(1.1);
  background-color: var(--accent);
  color: var(--text-light);
}

.mute-toggle-btn svg {
  width: 24px;
  height: 24px;
}

.catalogue-container {
  width: 100%;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.title-shop {
  font-size: 1.5rem; /* Reduced size for elegance */
  font-weight: 600;
  color: var(--dark);
  text-align: center;
  margin-bottom: 1rem;
}

.title {
  font-size: 1.2rem;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
  color: var(--gray);
}

/* Styles for Category List */
.category-list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  gap: 15px;
  padding: 10px 5px;
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;
  margin-block: 20px;
  scrollbar-width: none; /* Hide scrollbar Firefox */
  -ms-overflow-style: none; /* Hide scrollbar IE */
}

.category-list::-webkit-scrollbar {
  display: none; /* Hide scrollbar Chrome/Safari */
}

.category-item {
  flex: 0 0 auto;
  scroll-snap-align: start;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 80px; /* Slightly smaller */
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  border: none;
}

.category-item.active-cat p {
  color: var(--dark);
  font-weight: 700;
}

.category-item.active-cat img {
  border-color: var(--secondary);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.category-item img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: var(--radius);
  border: 1px solid var(--border, #e5e7eb);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.02);
  transition: all 0.3s ease;
  background-color: white;
  padding: 5px;
}

.category-item:hover img {
  border-color: var(--secondary);
}

.category-item p {
  font-weight: 500;
  text-align: center;
  width: 100%;
  margin-top: 8px;
  font-size: 0.8rem;
  color: var(--dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s;
}

.category-item:hover p {
  color: var(--dark);
}

.category-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

/* Boutons scroll */
.scroll-btn {
  position: absolute;
  z-index: 2;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: 0.2s;
}

.scroll-btn:hover {
  transform: scale(1.1);
}

.scroll-btn.left {
  left: 0;
}

.scroll-btn.right {
  right: 0;
}

/* Ajouter padding pour éviter overlap */
.category-list {
  padding-inline: 40px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* mobile smooth */
}
</style>
